import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import { Editor } from 'react-draft-wysiwyg';
import {
    EditorState, ContentState,
    convertToRaw, Modifier, RichUtils
} from 'draft-js';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-table/react-table.css';
import { SingleDatePicker } from 'react-dates';
import update from 'immutability-helper';
import HeaderPhrase from '../../Components/Header-Phrase/HeaderPhrase';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
// import incentivoDia1 from '../../Assets/Images/incentivo-dia-1-capa.jpg';
// import incentivoDia2 from '../../Assets/Images/incentivo-dia-2-capa.jpg';
// import incentivoDia3 from '../../Assets/Images/incentivo-dia-3-capa.jpg';
// import incentivoDia4 from '../../Assets/Images/incentivo-dia-4-capa.jpg';
// import incentivoDia5 from '../../Assets/Images/incentivo-dia-5-capa.jpg';
// import incentivoDia6 from '../../Assets/Images/incentivo-dia-6-capa.jpg';
// import incentivoDia7 from '../../Assets/Images/incentivo-dia-7-capa.jpg';
// import incentivoDia8 from '../../Assets/Images/incentivo-dia-8-capa.jpg';
// import incentivoDia9 from '../../Assets/Images/incentivo-dia-9-capa.jpg';
// import incentivoDia10 from '../../Assets/Images/incentivo-dia-10-capa.jpg';
// import incentivoDia11 from '../../Assets/Images/incentivo-dia-11-capa.jpg';
// import incentivoDia12 from '../../Assets/Images/incentivo-dia-12-capa.jpg';
// import incentivoDia13 from '../../Assets/Images/incentivo-dia-13-capa.jpg';
// import incentivoDia14 from '../../Assets/Images/incentivo-dia-14-capa.jpg';
// import incentivoDia15 from '../../Assets/Images/incentivo-dia-15-capa.jpg';
import './Phrase-of-the-Day.scss';


class PhraseDetails extends Component {
    constructor(props) {
        super(props);


        this.imagensFundo = [
            // {
            //     value: 1,
            //     src: incentivoDia1,
            //     alt: "folhagem verde"
            // },
            // {
            //     value: 2,
            //     src: incentivoDia2,
            //     alt: "onda roxa"
            // },
            // {
            //     value: 3,
            //     src: incentivoDia3,
            //     alt: "pôr do sol no mar",
            // },
            // {
            //     value: 4,
            //     src: incentivoDia4,
            //     alt: "fundo rosa com flor",
            // },
            // {
            //     value: 5,
            //     src: incentivoDia5,
            //     alt: "árvores e céu azul"
            // },
            // {
            //     value: 6,
            //     src: incentivoDia6,
            //     alt: "grama e céu azul"
            // },
            // {
            //     value: 7,
            //     src: incentivoDia7,
            //     alt: "céu roxo"
            // },
            // {
            //     value: 8,
            //     src: incentivoDia8,
            //     alt: "céu colorido"
            // },
            // {
            //     value: 9,
            //     src: incentivoDia9,
            //     alt: "fundo verde"
            // },
            // {
            //     value: 10,
            //     src: incentivoDia10,
            //     alt: "cidade com céu colorido"
            // },
            // {
            //     value: 11,
            //     src: incentivoDia11,
            //     alt: "fundo azul com flores"
            // },
            // {
            //     value: 12,
            //     src: incentivoDia12,
            //     alt: "uma árvore e céu azul"
            // },
            // {
            //     value: 13,
            //     src: incentivoDia13,
            //     alt: "folha e fundo verde"
            // },
            // {
            //     value: 14,
            //     src: incentivoDia14,
            //     alt: "barco a vela no mar"
            // },
            // {
            //     value: 15,
            //     src: incentivoDia15,
            //     alt: "fundo branco e azul"
            // },
            {
                value: 15,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-15-capa.jpg`,
                alt: "fundo branco e azul"
            },
            {
                value: 17,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-17-whatsapp.jpg`,
                alt: "novo layout amarelo"
            },
            {
                value: 18,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-18-whatsapp.jpg`,
                alt: "novo layout azul"
            },
            {
                value: 19,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-19-whatsapp.jpg`,
                alt: "novo layout verde"
            },
            {
                value: 20,
                src: `https://meubs.com.br/bs-mais/fundos-incentivo/incentivo-dia-20-whatsapp.jpg`,
                alt: "novo layout laranja"
            },

        ];

        this.criaTextoHTML = this.criaTextoHTML.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.habilitaSalvar = this.habilitaSalvar.bind(this);
        this.salvarAlteracoes = this.salvarAlteracoes.bind(this);
        this.removeEspacosHTML = this.removeEspacosHTML.bind(this);
        this.toggleModalPendencia = this.toggleModalPendencia.bind(this);
        this.toggleSucessoAlteracao = this.toggleSucessoAlteracao.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.apiFrase = this.apiFrase.bind(this);
        this.carregaFrase = this.carregaFrase.bind(this);
        this.excluirFrase = this.excluirFrase.bind(this);
        this.toggleModalExcluir = this.toggleModalExcluir.bind(this);
        this.applySmallTag = this.applySmallTag.bind(this);
        this.addStar = this.addStar.bind(this);
        this.blockStyleFn = this.blockStyleFn.bind(this);
        this._onSmallClick = this._onSmallClick.bind(this);
        this.replaceAll = this.replaceAll.bind(this);
        this.gerarImagem = this.gerarImagem.bind(this);
        this.parametrosPreview = this.parametrosPreview.bind(this);
        this.removeTagHTML = this.removeTagHTML.bind(this);
        this.voltar = this.voltar.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            novaFrase: this.props.match.params.idFrase === "nova-frase",
            isLoadingFrase: true,
            isLoadingAlteracoes: false,
            isLoadingExcluirFrase: false,
            isLoadingImagemGerada: false,
            temAlteracao: false,
            modalSucessoNovaFrase: false,
            modalExcluirFrase: false,
            habilitaSalvar: true,
            modalPendencia: false,
            pendencias: [],
            hasError: false,
            errorMessage: '',
            // verificacaoAcesso: false,
            frase: {},
            autor: 'Daisaku Ikeda',
            extraido: 'Frase publicada no Seikyo Shimbun',
            previaFrase: '[frase]',
            dtFraseAux: moment().add(1, "days"),
            tipoImg: "wpp",
            styleFrase: {
                wpp: {
                    fontSize: 52.8
                },
                ig: {
                    fontSize: 83.2
                }
            },
            pFontSize: {
                wpp: 52.8,
                ig: 82.2
            },
            pFontSizeWPP: 52.8,
            pFontSizeIG: 83.2,
            sucessoImagem: false,
        };

        this.tagSmallToolbar =
            <div onClick={this.applySmallTag} className="rdw-image-wrapper" aria-haspopup="true" aria-expanded="false" aria-label="rdw-image-control">
                <div className="rdw-option-wrapper" title="Small">
                    <em>small</em>
                </div>
            </div>;

        this.toolbar = {
            inline: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['bold', 'italic', 'underline', 'subscript', 'superscript'],
            },
            blockType: {
                inDropdown: true,
                options: [],
                className: 'd-none'
            },
            fontSize: {
                options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                className: 'd-none',
                component: undefined,
                dropdownClassName: undefined,
            },
            fontFamily: {
                options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'],
                className: 'd-none',
                component: undefined,
                dropdownClassName: undefined,
            },
            list: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: [],
            },
            textAlign: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['center'],
            },
            colorPicker: {
                className: 'd-none',
                component: undefined,
                popupClassName: undefined,
                colors: [],
            },
            link: {
                inDropdown: false,
                className: 'd-none',
                component: undefined,
                popupClassName: undefined,
                dropdownClassName: undefined,
                showOpenOptionOnHover: true,
                defaultTargetOption: '_self',
                options: ['link', 'unlink'],
                linkCallback: undefined
            },
            emoji: {
                className: 'd-none',
                component: undefined,
                popupClassName: undefined,
                emojis: [
                    '😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓',
                    '😛', '😜', '😠', '😇', '😷', '😈', '👻', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈',
                    '🙉', '🙊', '👼', '👮', '🕵', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙇', '🚶', '🏃', '💃',
                    '⛷', '🏂', '🏌', '🏄', '🚣', '🏊', '⛹', '🏋', '🚴', '👫', '💪', '👈', '👉', '👉', '👆', '🖕',
                    '👇', '🖖', '🤘', '🖐', '👌', '👍', '👎', '✊', '👊', '👏', '🙌', '🙏', '🐵', '🐶', '🐇', '🐥',
                    '🐸', '🐌', '🐛', '🐜', '🐝', '🍉', '🍄', '🍔', '🍤', '🍨', '🍪', '🎂', '🍰', '🍾', '🍷', '🍸',
                    '🍺', '🌍', '🚑', '⏰', '🌙', '🌝', '🌞', '⭐', '🌟', '🌠', '🌨', '🌩', '⛄', '🔥', '🎄', '🎈',
                    '🎉', '🎊', '🎁', '🎗', '🏀', '🏈', '🎲', '🔇', '🔈', '📣', '🔔', '🎵', '🎷', '💰', '🖊', '📅',
                    '✅', '❎', '💯',
                ],
            },
            embedded: {
                className: 'd-none',
                component: undefined,
                popupClassName: undefined,
                embedCallback: undefined,
                defaultSize: {
                    height: 'auto',
                    width: 'auto',
                },
            },
            image: {
                className: "d-none",
                component: undefined,
                popupClassName: undefined,
                urlEnabled: true,
                uploadEnabled: true,
                alignmentEnabled: true,
                uploadCallback: undefined,
                previewImage: false,
                inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                alt: { present: false, mandatory: false },
                defaultSize: {
                    height: 'auto',
                    width: 'auto',
                },
            },
            remove: { className: undefined, component: undefined },
            history: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['undo', 'redo'],
            },
        };

        this.styleMap = {
            'SUBSCRIPT': {
                // fontSize: (this.state.styleFrase[this.state.tipoImg].fontSize)/2 
                // fontSize: 'smaller'
                fontSize: 8
            },
        };

    }

    applySmallTag() {
        // // const blockRenderMap = Immutable.Map({
        // //     'small': {
        // //         element: 'small'
        // //     }
        // // });

        // // const extendedBlockRenderMap = this.state.contentStateTexto.DefaultDraftBlockRenderMap.merge(blockRenderMap);
        // console.log("this.ref", this.ref)
        // // console.log("getCurrentContent", this.state.editorStateTexto.getCurrentContent(),)
        // // console.log("DraftBlockType", this.state.editorStateTexto.getSelection())
        // console.log("getSelection", this.state.editorStateTexto.getSelection())
        // console.log("convertToRaw", convertToRaw(this.state.editorStateTexto.getCurrentContent()));
        // console.log("draftToHTML", draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent())));

        // // this.addStar();

        // // console.log("draft", ContentState.getBlockMap());
        this._onSmallClick();


    }

    _onSmallClick() {
        this.onEditorStateChange(RichUtils.toggleInlineStyle(this.state.editorStateTexto, 'SUBSCRIPT'), "editorStateTexto");
    }

    blockStyleFn(contentBlock) {
        return console.log("contentBlock:", contentBlock.getText());
        // if (contentBlock.getText() === 'Hii') {
        //   return 'cssClassToUseOnEveryHii';
        // }
    }

    addStar() {
        const contentState = Modifier.replaceText(
            this.state.editorStateTexto.getCurrentContent(),
            this.state.editorStateTexto.getSelection(),
            <small>teste</small>,
            this.state.editorStateTexto.getCurrentInlineStyle(),
        );
        // this.onEditorStateChange(EditorState.push(this.state.editorStateTexto, contentState, 'insert-characters'), "editorStateTexto");
        this.onEditorStateChange(EditorState.push(this.state.editorStateTexto, contentState, 'change-inline-style'), "editorStateTexto");
    }

    componentDidMount() {
        this.setState({ isLoadingFrase: true });
        // if (this.state.verificacaoAcesso) {
        if (!this.state.novaFrase) {
            this.apiFrase();
        }
        else {
            this.setState({
                fraseDoDia: {
                    frase: '',
                    autor: '',
                    habilitado: true
                },
                bgGradient: moment().format("dddd").split("-")[0].toLowerCase(),
                editorStateTexto: EditorState.createEmpty(),
                imagemSelecionada: 15
            }, () => this.setState({ isLoadingFrase: false }))
        };
        // }
    }

    criaTextoHTML(texto) { return { __html: texto } }

    onEditorStateChange(_editorState, _opcao) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({
            sucessoImagem: false,
            [_opcao]: _editorState,
        }, () => {
            let _novoHTML = this.replaceAll(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent())), '<sub>', '<small>');
            _novoHTML = this.replaceAll(_novoHTML, '</sub>', '</small>');
            this.setState({
                previaFrase: this.removeEspacosHTML(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent()))) !== "" ?
                    <div dangerouslySetInnerHTML={this.criaTextoHTML(_novoHTML)} />
                    :
                    '[frase]'
            })
        });
    }

    habilitaSalvar() {
        const _autorValido = this.state.autor.trim() !== '',
            _textoValido = this.removeEspacosHTML(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent()))) !== "",
            _fundoValido = !!this.state.imagemSelecionada && this.state.imagemSelecionada >= 1;

        const _infosObrigatorias = [
            { campo: "Autor", valido: _autorValido },
            { campo: "Texto", valido: _textoValido },
            { campo: "Imagem de fundo", valido: _fundoValido }
        ]

        const _pendencias = _infosObrigatorias.filter(item => !item.valido);

        this.setState({ habilitaSalvar: _autorValido * _textoValido * _fundoValido }, () => this.salvarAlteracoes(_pendencias))
    }

    salvarAlteracoes(_pend) {
        if (this.state.habilitaSalvar) {
            // const _textoAtual = draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent()))
            const _textoAtual = this.state.previaFrase.props.dangerouslySetInnerHTML.__html;
            const _temTexto = this.removeEspacosHTML(_textoAtual) !== "";

            const _salvarFrase = {
                frase: _temTexto ? _textoAtual : '',
                autor: this.state.autor,
                dtFrase: this.state.dtFraseAux,
                styleFrase: this.state.styleFrase,
                extraido: this.state.extraido,
                tipoFundo: parseInt(this.state.imagemSelecionada, 10),
                notas: this.state.notas
            }

            this.setState({ frase: _salvarFrase, isLoadingAlteracoes: true }, () => {
                if (this.state.novaFrase) {
                    axios.post(this.Configurations.apiBasePath + `/frase-do-dia/nova-frase`, _salvarFrase).then(response => {
                        this.setState({ temAlteracao: false, idFraseNova: response.data.idFrase, sucessoNovaFrase: true }, () => {
                            this.toggleSucessoAlteracao();
                        })
                    }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
                } else {
                    axios.put(this.Configurations.apiBasePath + `/frase-do-dia/${this.state.idFrase}`, _salvarFrase).then(response => {
                        this.toggleSucessoAlteracao();
                        this.setState({ temAlteracao: false })
                    }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
                }
            })
        } else {
            this.setState({ pendencias: _pend }, () => this.toggleModalPendencia());
        }
    }

    replaceAll(string, search, replace) {
        return string.split(search).join(replace);
    }

    removeEspacosHTML(_strHTML) {
        if ((_strHTML === null) || (_strHTML === ''))
            return "";
        else
            _strHTML = _strHTML.toString();
        return _strHTML.replace(/<[^>]*>/g, '').replace(/(\r\n|\n|\r)/gm, "").replace(/&nbsp;/g, '');
    }

    toggleSucessoAlteracao() {
        this.setState({ modalSucessoAlteracao: !this.state.modalSucessoAlteracao }, () => {
            if (!this.state.modalSucessoAlteracao && this.state.sucessoNovaFrase) this.props.history.push(`/frase-do-dia/detalhes/${this.state.idFraseNova}`)
        })
    }

    toggleModalPendencia() {
        this.setState({ modalPendencia: !this.state.modalPendencia })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message, errorGoBack: err.response.data.goBack })
    }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "", errorGoBack: false }) }

    handleOnChange(e, tipoImg) {
        const _name = e.target.name,
            _value = e.target.value;
        if (_name !== 'tipoImg') e.preventDefault();
        this.setState({ [_name]: _value, temAlteracao: true, sucessoImagem: false, }, () => {
            if (_name === 'pFontSize') {
                const _fontValue = parseFloat(_value, 10);
                this.setState({ styleFrase: update(this.state.styleFrase, { [tipoImg]: { fontSize: { $set: _fontValue } } }) })
            }
        })
    }

    onDateChange(date) {
        if (moment(date).isValid()) {
            if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
            this.setState({
                sucessoImagem: false,
                dtFraseAux: date,
                bgGradient: moment(date).format("dddd").split("-")[0].toLowerCase(),
            })
        };
    }

    apiFrase() {
        this.setState({ isLoadingFrase: true });
        axios.get(this.Configurations.apiBasePath + `/frase-do-dia/${this.props.match.params.idFrase}`).then(response => {
            this.carregaFrase(response.data.fraseDoDia)
        }).catch(this.handleError);
    }

    carregaFrase(_fraseDoDia) {

        let _editorStateTexto, _fraseHtml;
        _fraseHtml = this.replaceAll(_fraseDoDia.frase, "<small", "<sub");
        _fraseHtml = this.replaceAll(_fraseHtml, "</small>", "</sub>");
        const _temTexto = this.removeEspacosHTML(_fraseHtml) !== "",
            _style = _fraseDoDia.styleFrase ? _fraseDoDia.styleFrase : this.state.styleFrase;

        if (_temTexto) {
            // const contentBlockTexto = htmlToDraft(_fraseDoDia.frase);
            const contentBlockTexto = htmlToDraft(_fraseHtml);
            if (contentBlockTexto) {
                const contentStateTexto = ContentState.createFromBlockArray(contentBlockTexto.contentBlocks);
                _editorStateTexto = EditorState.createWithContent(contentStateTexto);
                this.setState({ contentStateTexto: contentStateTexto })
            }
        } else {
            _editorStateTexto = EditorState.createEmpty();
        }

        this.setState({
            editorStateTexto: _editorStateTexto,
        }, () => {
            let _novoHTML = this.replaceAll(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent())), '<sub>', '<small>');
            _novoHTML = this.replaceAll(_novoHTML, '</sub>', '</small>');
            // let _novoHTML = draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent()));
            this.setState({
                previaFrase: this.removeEspacosHTML(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent()))) !== "" ?
                    <div dangerouslySetInnerHTML={this.criaTextoHTML(_novoHTML)} />
                    :
                    '[frase]',
                fraseDoDia: _fraseDoDia,
                styleFrase: _style,
                dtFraseAux: _fraseDoDia.dtFrase,
                idFrase: _fraseDoDia._id,
                extraido: (!!_fraseDoDia.extraido && _fraseDoDia.extraido.trim() !== '') ? _fraseDoDia.extraido : 'Frase publicada no Seikyo Shimbun',
                imagemSelecionada: _fraseDoDia.tipoFundo || 15,
                bgGradient: moment(_fraseDoDia.dtFrase).format("dddd").split("-")[0].toLowerCase(),
                autor: _fraseDoDia.autor,
                notas: _fraseDoDia.notas
            }, () => this.setState({ isLoadingFrase: false }))
        });
    }

    toggleModalExcluir() { this.setState({ modalExcluirFrase: !this.state.modalExcluirFrase }) }

    excluirFrase() {
        this.setState({ isLoadingExcluirFrase: true }, () => {
            axios.delete(this.Configurations.apiBasePath + `/frase-do-dia/${this.state.idFrase}`).then(response => {
            }).catch(this.handleError).finally(() => this.setState({ isLoadingExcluirFrase: false }, () => {
                this.toggleModalExcluir();
                this.props.history.push('/frase-do-dia/lista?pagina=1&limite=10');
            }))
        })
    }

    gerarImagem() {
        this.setState({ isLoadingGerarImagem: true, sucessoImagem: false })
        axios.get(this.Configurations.apiBasePath + `/frase-do-dia/gerar-imagens/${this.state.idFrase}`).then(response => {
            this.setState({ sucessoImagem: true })
        }).catch(this.handleError)
            .finally(() => {
                this.setState({ isLoadingGerarImagem: false }, () => {
                    // if (this.state.sucessoImagem) window.open(`https://meubs.com.br/bs-mais/incentivos/incentivo-whatsapp-${moment(this.state.dtFraseAux).format("YYYY-MM-DD")}.png?v=${Math.random() * 123}`, "_blank");
                })
            });
    }

    voltar() {
        if (this.props.temAlteracao) this.toggleModalAlteracoes();
        else window.history.go(-1);
    }

    parametrosPreview(_fraseFinal) {
        _fraseFinal = _fraseFinal.toString();
        _fraseFinal = _fraseFinal.replace(/<[^>]*>/g, '').replace(/(\r\n|\n|\r)/gm, "").replace(/&nbsp;/g, '');
        const _multiplier = 2;
        let _fontSize = 18,
            // _lineHeight = 22, 
            _lineHeight = 28,
            // _marginTop = 170, 
            _marginTop = 50,
            // _marginBottom = 50,
            _marginSides = 40;
        if (_fraseFinal.length >= 50 && _fraseFinal.length < 201) {
            _fontSize = 16;
            // _lineHeight = 20;
            _lineHeight = 24;
            // _marginTop = 160;
            _marginTop = 55;
            // _marginBottom = 55;
            _marginSides = 100;
        } else if (_fraseFinal.length >= 201 && _fraseFinal.length < 231) {
            _fontSize = 16;
            // _lineHeight = 20;
            _lineHeight = 24;
            // _marginTop = 130;
            _marginTop = 45;
            // _marginBottom = 45;
            _marginSides = 60;
        } else if (_fraseFinal.length >= 231) {
            _fontSize = 16;
            // _lineHeight = 20;
            _lineHeight = 24;
            // _marginTop = 130;
            _marginTop = 40;
            // _marginBottom = 40;
        }
        // return { _fontSize, _lineHeight, _marginSides, _marginTop, _multiplier }
        return {
            fontSize: _multiplier * _fontSize,
            lineHeight: `${_multiplier * _lineHeight}px`,
            marginLeft: _multiplier * _marginSides,
            marginRight: _multiplier * _marginSides,
            marginTop: _multiplier * _marginTop,
            // marginBottom: _multiplier * _marginBottom,
        }
    }

    removeTagHTML(strHTML) {
        strHTML = strHTML.toString();
        strHTML = strHTML.replace(/<[^>]*>/g, '').replace(/(\r\n|\n|\r)/gm, "").replace(/&nbsp;/g, '');
        return strHTML
    }

    render() {
        return (
            <div className="row frase-do-dia detalhes-frase">
                {!this.state.isLoadingFrase && (
                    // {!this.state.isLoadingFrase && this.state.verificacaoAcesso && (
                    <HeaderPhrase
                        flagNovaFrase={this.state.novaFrase}
                        salvarAlteracoes={this.habilitaSalvar}
                        fraseDoDia={this.state.fraseDoDia}
                        // mudaStatusFrases={this.mudaStatusFrases}
                        temAlteracao={this.state.temAlteracao}
                        novaFrase={this.state.novaFrase}
                        isLoadingAlteracoes={this.state.isLoadingAlteracoes}
                        isLoadingFrase={this.state.isLoadingFrase}
                        isLoadingExcluir={this.state.isLoadingExcluirFrase}
                        isLoadingGerarImagem={this.state.isLoadingGerarImagem}
                        excluirFrase={this.toggleModalExcluir}
                        gerarImagem={this.gerarImagem}
                        history={this.props.history}
                        date={this.state.dtFraseAux}
                    />
                )}
                <div className="div-frase">
                    <div className="col-12">
                        {this.state.isLoadingFrase ? (
                            <div className="row no-gutters">
                                <div className="col-12 text-center">
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            </div>
                        ) : (
                            <div className="row">
                                <div className="col-12 text-center text-lg-left">
                                    <h3 className="d-none d-lg-block">{this.state.novaFrase ? 'Nova' : 'Editar'} Frase do Dia - {moment(this.state.dtFraseAux).format("DD/MM/YYYY")}</h3>
                                    <h3 className="d-lg-none">{this.state.novaFrase ? 'Nova' : 'Editar'} Frase do Dia</h3>
                                    <h5 className="d-lg-none">{moment(this.state.dtFraseAux).format("DD/MM/YYYY")}</h5>
                                </div>

                                <div className="col-12 col-lg-6 px-3 py-2 m-0 form-group">
                                    <div className="row">
                                        <div className="col-12 col-lg-12 py-2">
                                            <small><small>(*)</small> informações obrigatórias</small>
                                        </div >
                                        <div className="col-12 px-3 pt-2 mb-1">
                                            <span className="mr-2">Data da Frase do Dia <sup><small>(*)</small></sup></span>
                                        </div>
                                        <div className="col-12 px-3 pb-2">
                                            <SingleDatePicker
                                                date={this.state.dtFraseAux !== null ? moment(this.state.dtFraseAux) : null} // momentPropTypes.momentObj or null
                                                onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                                focused={this.state.focused} // PropTypes.bool
                                                onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                                id="your_unique_id" // PropTypes.string.isRequired,
                                                orientation="horizontal"
                                                anchorDirection="left"
                                                openDirection="down"
                                                verticalHeight={450}
                                                numberOfMonths={1}
                                                small={true}
                                                placeholder=""
                                                displayFormat="DD/MM/YY"
                                                isOutsideRange={date => false}
                                                disabled={!this.state.novaFrase}
                                            />
                                            {!this.state.novaFrase && <small className="mx-2 text-secondary">Não é possível alterar a data de uma frase já cadastrada.</small>}
                                        </div>
                                        <div className="col-6 px-3 py-2">
                                            <label>Autor <sup><small>(*)</small></sup></label>
                                            <input name="autor" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.autor}>
                                            </input>
                                        </div>
                                        <div className="col-12 col-lg-6 px-3 py-2">
                                            <label>Origem <sup><small>(*)</small></sup></label>
                                            <input name="extraido" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.extraido}>
                                            </input>
                                        </div>
                                        <div className="col-12 px-3 py-2">
                                            <label>Texto <sup><small>(*)</small></sup></label>
                                            <Editor
                                                editorState={this.state.editorStateTexto}
                                                wrapperClassName="demo-wrapper"
                                                onEditorStateChange={(editorState) => this.onEditorStateChange(editorState, "editorStateTexto")}
                                                // toolbarHidden={true}
                                                toolbar={this.toolbar}
                                                // toolbarCustomButtons={[
                                                //     this.tagSmallToolbar,
                                                // ]}
                                                toolbarClassName="custom-toolbar"
                                                editorClassName="custom-editor-texto border px-3"
                                                handlePastedText={() => false}
                                                // blockRenderMap={this.state.contentStateTexto.DefaultDraftBlockRenderMap}
                                                // blockStyleFn={this.blockStyleFn}
                                                // blockRenderMap={blockRenderMap}
                                                ref={(ref) => this.ref = ref}
                                                customStyleMap={this.styleMap}
                                            />
                                        </div>
                                        <div className="col-12 col-lg-12 px-3 py-2">
                                            <label>Notas</label>
                                            <textarea id="descr" type="text" className="form-control" name="notas" value={this.state.notas} onChange={this.handleOnChange} rows="5" />
                                        </div>
                                        <div className="col-12 py-3">
                                            <div className="row px-3">
                                                <div className="card w-100">
                                                    <div className="card-body">
                                                        <div className="col-12">
                                                            <div className="row">
                                                                <label>Selecione o fundo de imagem: </label>
                                                                <div className="row">
                                                                    {this.imagensFundo.map((item, index) => {
                                                                        return (
                                                                            <div className={`col-3 col-lg-2 p-2 opcao-fundo-imagem cursor-pointer ${item.value === this.state.imagemSelecionada ? 'selecionado' : 'nao-selecionado'}`} key={index} onClick={() => this.setState({ imagemSelecionada: item.value, temAlteracao: true, sucessoImagem: false, })}>
                                                                                <img className="img img-fluid" src={item.src} alt={item.alt} />
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="col-6 text-center">
                                                <div className="row no-gutters">
                                                    <div className="col-12 px-3 py-1">
                                                        <small>Fonte principal p/ Whatsapp:</small>
                                                    </div>
                                                    <div className="offset-4 col-4 py-1">
                                                        <input name="pFontSize" data-tipo="wpp" type="number" className="form-control input-font-size" onChange={e => this.handleOnChange(e, 'wpp')} value={this.state.styleFrase.wpp.fontSize}>
                                                        </input>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6 text-center">
                                                <div className="row no-gutters">
                                                    <div className="col-12 px-3 py-1">
                                                        <small>Fonte principal p/ Instagram:</small>
                                                    </div>
                                                    <div className="offset-4 col-4 py-1">
                                                        <input name="pFontSize" data-tipo="ig" type="number" className="form-control input-font-size" onChange={e => this.handleOnChange(e, 'ig')} value={this.state.styleFrase.ig.fontSize}>
                                                        </input>
                                                    </div>
                                                </div>
                                            </div> */}
                                    </div>
                                </div>
                                {!this.state.isLoadingFrase && !!this.state.previaFrase && (
                                    <div className="col-12 col-lg-6">
                                        <div className="row no-gutters">
                                            {/* <div className="col-12 text-center py-2">
                                                    <strong className="m-0">Prévia da imagem</strong>
                                                </div>
                                                <div className="col-12 py-2 text-center">
                                                    <div className="form-check form-check-inline mx-4">
                                                        <input className="form-check-input" type="radio" name="tipoImg" id="wpp" checked={this.state.tipoImg === "wpp"} value={"wpp"} onChange={this.handleOnChange} />
                                                        <label className="form-check-label pointer" htmlFor="wpp">WhatsApp</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mx-4">
                                                        <input className="form-check-input" type="radio" name="tipoImg" id="ig" checked={this.state.tipoImg === "ig"} value={"ig"} onChange={this.handleOnChange} />
                                                        <label className="form-check-label pointer" htmlFor="ig">Instagram</label>
                                                    </div>
                                                </div> */}
                                            {this.state.temAlteracao && (
                                                <div className="col-12 text-center">
                                                    <div className={`card bg-warning font-weight-bold`}>
                                                        <div className="card-body p-1">
                                                            <div className="row no-gutters">
                                                                <div className="col-12 text-center">
                                                                    <p className="m-0">Antes de gerar a imagem, é necessário salvar as alterações pendentes.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {this.state.sucessoImagem && (
                                                <div className="col-12 text-center">
                                                    <div className={`card bg-success text-white font-weight-bold`}>
                                                        <div className="card-body p-1">
                                                            <div className="row no-gutters">
                                                                <div className="col-12 text-center">
                                                                    <p className="m-0">Imagem gerada com sucesso!</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {!this.state.novaFrase && !this.state.temAlteracao && (
                                                <div className='col-12 text-center'>
                                                    <div className="row no-gutters my-4 my-lg-0">
                                                        <div className='col-4 text-center'>
                                                            {/* <a target="_blank" rel="noopener noreferrer" href={`https://meubs.com.br/bs-mais/incentivos/incentivo-whatsapp-${moment(this.state.dtFraseAux).format("YYYY-MM-DD")}.png?v=${Math.random() * 123}`}>whatsapp</a> */}
                                                            <button className='btn btn-sm btn-outline-success' onClick={() => window.open(`https://meubs.com.br/bs-mais/incentivos/incentivo-whatsapp-${moment(this.state.dtFraseAux).format("YYYY-MM-DD")}.png?v=${Math.random() * 123}`, "_blank")}>WhatsApp</button>
                                                        </div>
                                                        <div className='col-4 text-center'>
                                                            {/* <a target="_blank" rel="noopener noreferrer" href={`https://meubs.com.br/bs-mais/incentivos/incentivo-instagram-${moment(this.state.dtFraseAux).format("YYYY-MM-DD")}.png?v=${Math.random() * 123}`}>instagram</a> */}
                                                            <button className='btn btn-sm btn-outline-purple' onClick={() => window.open(`https://meubs.com.br/bs-mais/incentivos/incentivo-instagram-${moment(this.state.dtFraseAux).format("YYYY-MM-DD")}.png?v=${Math.random() * 123}`, "_blank")}>Instagram</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className={`col-12 d-none d-lg-block text-white px-3 previa-imagem-${this.state.tipoImg}`}>
                                                <body>
                                                    {/* <div className={`phrase-container gradient-background-${this.state.bgGradient}`}> */}
                                                    {/* <div className={`phrase-container`} style="background-image: url(http://i54.tinypic.com/4zuxif.jpg)"> */}
                                                    <div className={`phrase-container background-imagem-frase`} style={{ backgroundImage: `url(${this.imagensFundo.filter(item => item.value === this.state.imagemSelecionada)[0].src})` }}>
                                                        <div className="phrase-content text-dark">
                                                            <div className="text-center">
                                                                <img src="http://meubs.com.br/assets/bs-mais/logo-final-512.jpg" className="bs-mais-logo" alt="BS+" />
                                                                <p className="text-uppercase cabecalho">Aos meus companheiros</p>
                                                                <time>{this.state.dtFraseAux ?
                                                                    moment(this.state.dtFraseAux).format("LL").toLowerCase() : '[data]'
                                                                }</time>
                                                            </div>
                                                            {/* <hr /> */}
                                                            {/* <p className="text-center" style={this.state.styleFrase[this.state.tipoImg]}>{this.state.previaFrase}</p> */}
                                                            <p className="text-center" style={this.parametrosPreview(this.state.previaFrase)}>{this.state.previaFrase}</p>
                                                            {/* <p className="text-center" style={this.parametrosPreview(this.state.previaFrase)}>
                                                                    {this.removeTagHTML(this.state.previaFrase)}
                                                                </p> */}
                                                            <div className="text-center mt-5">
                                                                <strong className="autor">{this.state.autor.trim() !== '' ? this.state.autor : '[autor]'}</strong>
                                                                <br />
                                                                <small className="rodape">({this.state.extraido})</small><br />
                                                                <small>Enviado pelo aplicativo <strong>BS+</strong></small>
                                                                <br />
                                                                {/* <img src="http://meubs.com.br/assets/bs-mais/logo-final-512.jpg" className="bs-mais-logo" alt="BS+" /> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </body>
                                            </div>

                                        </div>
                                    </div>
                                )}
                                <div className="col-12 d-lg-none">
                                    <div className="row pt-3 px-3">
                                        <div className="col-12 text-center">
                                            <button disabled={!this.state.temAlteracao} onClick={this.salvarAlteracoes} className="btn btn-outline-success">{this.state.novaFrase ? 'criar frase' : 'salvar alterações'}</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 d-lg-none pt-3">
                                    <div className="row px-3">
                                        <div className="col-12 text-center">
                                            <button disabled={this.state.flagNovaFrase || this.state.temAlteracao} onClick={this.gerarImagem} className="btn btn-outline-primary">gerar imagem</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 d-lg-none">
                                    <div className="row pt-3 px-3">
                                        <div className="col-12 text-center">
                                            <button onClick={this.toggleModalExcluir} className="btn btn-outline-danger">excluir frase</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 d-lg-none">
                                    <div className="row pt-3 px-3 pb-3">
                                        <div className="col-12 text-center mb-4">
                                            <button onClick={this.voltar} className="btn btn-outline-secondary">voltar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <Modal isOpen={this.state.modalSucessoAlteracao} toggle={this.toggleSucessoAlteracao}>
                    <ModalHeader toggle={this.toggleSucessoAlteracao}>
                        {this.state.novaFrase ? 'Nova Frase do Dia' : 'Edição de Frase do Dia'}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.novaFrase ? 'Nova Frase do Dia criada com sucesso! :)' : 'Alterações realizadas com sucesso! :)'}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.toggleSucessoAlteracao}>ok</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalPendencia} toggle={this.toggleModalPendencia}>
                    <ModalHeader toggle={this.toggleModalPendencia}>Campos obrigatórios</ModalHeader>
                    <ModalBody>
                        <p>Por favor, preencha o(s) seguinte(s) campo(s) obrigatório(s):</p>
                        <ul>
                            {this.state.pendencias && this.state.pendencias.map((item, index) => {
                                return <li key={`campo-${index}`}>{item.campo}</li>
                            })}
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleModalPendencia}>ok</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modalExcluirFrase} toggle={this.toggleModalExcluir}>
                    <ModalHeader toggle={this.toggleModalExcluir}>Excluir Frase</ModalHeader>
                    <ModalBody>
                        <p className="m-0">Tem certeza que deseja excluir a <strong>Frase Do Dia de {moment(this.state.dtFraseAux).format("DD/MM/YY")}</strong>? Essa operação não poderá ser desfeita.</p>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingExcluirFrase ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingExcluirFrase} color='danger' onClick={this.excluirFrase}>excluir</Button>
                        )}
                        {' '}<Button color="secondary" onClick={this.toggleModalExcluir}>voltar</Button>
                    </ModalFooter>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    // direcionaURL={'/conteudo'}
                    goBack={this.state.errorGoBack}
                />
            </div >
        )

    }
}

export default PhraseDetails;
